import WidgetResourcesFr from "../resources/widget.fr";
import WidgetResourcesEn from "../resources/widget.en";
import TemplateLoader from "./templatesLoader";
import ComponentsLoader from "./componentsLoader";
import NewsService from "../services/news/newsService";
import DocumentCentreSearchService from "../services/documentCentre/searchService";
import DocumentCentreQuerySuggestService from "../services/documentCentre/querySuggestService";
import DocumentCentreDocumentService from "../services/documentCentre/documentService";
import DocumentCentreFavouriteDocumentBehavior from "../behaviors/documentCentre/favouriteDocumentBehavior";
import DocumentCentreFavouriteDocumentListBehavior from "../behaviors/documentCentre/favouriteDocumentListBehavior";
import DocumentCentreAdvancedSearchBarBehavior from "../behaviors/documentCentre/advancedSearchBarBehavior";
import UserPreferencesService from "../services/login/UserPreferencesService";
import LoginUiBehavior from "../behaviors/login/uiBehavior";
import PromotionService from "../services/promotion/promotionService";
import InstabilityMessagesService from "../services/instabilityMessages/instabilityMessagesService";
import ContractService from "../services/corporateSearch/corporateSearchService";
import AdsService from "../services/ads/adsService";
import AdsSlideshowBehavior from "../behaviors/ads/adsSlideshowBehavior";
import UpcomingUnavailabilityService from "../services/upcomingUnavailability/upcomingUnavailabilityService";
import ContentService = EECore.Services.ContentService;

export default class InjectionConfig {

  static registerInjection(): void {
    const injector = EECore.Injection.Injector;
    const culture: EECore.Culture = injector.resolve(EECore.Registrations.CULTURE);
    injector.registerType("WidgetResources", this.getWidgetResources(culture));
    injector.registerType("WidgetTemplateLoader", new TemplateLoader(null));
    injector.registerType("WidgetComponentLoader", new ComponentsLoader(null));
    injector.registerType("NewsService", new NewsService(null, null, null, null));
    injector.registerType("DocumentCentreSearchService", new DocumentCentreSearchService(null, null, null, null));
    injector.registerType("EEWidget.DocumentCentre.QuerySuggestService", new DocumentCentreQuerySuggestService(null, null, null));
    injector.registerType("DocumentCentreDocumentService", new DocumentCentreDocumentService(null, null));
    injector.registerType("DocumentCentreFavouriteDocumentBehavior", new DocumentCentreFavouriteDocumentBehavior(null));
    injector.registerType("DocumentCentreFavouriteDocumentListBehavior", new DocumentCentreFavouriteDocumentListBehavior(null));
    injector.registerType("DocumentCentreAdvancedSearchBarBehavior", new DocumentCentreAdvancedSearchBarBehavior());
    injector.registerType("UserPreferencesService", new UserPreferencesService(null));
    injector.registerType("LoginUiBehavior", new LoginUiBehavior());
    injector.registerType("PromotionService", new PromotionService(null));
    injector.registerType("InstabilityMessagesService", new InstabilityMessagesService(null, null, null));
    injector.registerType("CorporateSearchService", new ContractService(null));
    injector.registerType("AdsSlideshowBehavior", new AdsSlideshowBehavior(null));
    injector.registerType("ContentService", new ContentService(null, null, null, null));
    injector.registerType("AdsService", new AdsService(null));
    injector.registerType("UpcomingUnavailabilityService", new UpcomingUnavailabilityService(null));
  }

  private static getWidgetResources(culture: EECore.Culture) {
    return culture.getCurrentCulture().indexOf("fr") === 0 ? WidgetResourcesFr : WidgetResourcesEn;
  }
}